import React, { useCallback } from 'react';
import { CircularProgress, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { BuscarCnpjInputProps } from './cnpj-input-props';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import { useConsultaCnpj } from 'servicos/webservice-saurus-utils/consulta-cnpj';
import { isCnpjNumerico, maskCnpj } from 'utils/cpfcnpj-format';
import { MASCARA_CNPJ, validarCNPJ } from 'utils/cpfcnpj-validate';

export function CnpjInput(props: BuscarCnpjInputProps) {
  const { consultarCNPJ, carregando } = useConsultaCnpj();

  const {
    UF,
    quandoEncontrarUmCnpjExecutar,
    hasButton,
    onChange,
    onBlur,
    value,
    InputProps,
    inputProps,
    ...outros
  } = props;

  const aplicarMascara = useCallback((valor: string) => maskCnpj(valor || ''), []);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const valorMascarado = aplicarMascara(event.target.value);
      if (onChange) {
        onChange({
          ...event,
          target: { ...event.target, value: valorMascarado, name: event.target.name },
        });
      }
    },
    [aplicarMascara, onChange],
  );

  const handleBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      const valorMascarado = aplicarMascara(event.target.value);
      if (onBlur) {
        onBlur({
          ...event,
          target: { ...event.target, value: valorMascarado, name: event.target.name },
        });
      }
    },
    [aplicarMascara, onBlur],
  );

  const consultarSefaz = useCallback(async () => {
    const valor = (value as string) || '';
    if (!MASCARA_CNPJ.test(valor) || !validarCNPJ(valor) || !isCnpjNumerico(valor)) {
      return;
    }
    const result = await consultarCNPJ(valor, UF as string);
    if (result?.sucesso && quandoEncontrarUmCnpjExecutar !== undefined) {
      quandoEncontrarUmCnpjExecutar(result.dados.retConsultaDocumento.CadastroLocalizado);
    }
  }, [UF, consultarCNPJ, quandoEncontrarUmCnpjExecutar, value]);

  return (
    <TextField
      {...outros}
      value={aplicarMascara((value as string) || '')}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{
        ...inputProps,
        inputMode: 'text',
      }}
      InputProps={{
        ...InputProps,
        endAdornment: hasButton ? (
          <InputAdornment position="end">
            <IconButton
              onClick={consultarSefaz}
              disabled={props.disabled}
              edge="end"
            >
              {carregando ? <CircularProgress size={25} /> : <SearchRoundedIcon />}
            </IconButton>
          </InputAdornment>
        ) : InputProps?.endAdornment ?? null,
      }}
    />
  );
}
